import {INavItem} from "./Models/INavItem";
import {TvIcon, TvIconSolid} from "../icons/TvIcon";
import NavItem from "./NavItem";
import {HomeIcon} from "@heroicons/react/24/outline";
import {ListBulletIcon} from "@heroicons/react/24/solid";

export const NavMobileBottomBar = () => {
    const NavItems: INavItem[] = [
        {title: "Główna", icon: <HomeIcon className="w-8 h-8"/>, href: "/"},
        {
            title: "TV",
            icon: <TvIcon className="w-8 h-8"/>,
            iconActive: <TvIconSolid className="w-8 h-8"/>,
            href: "/kanaly-tv",
        },
        {
            title: "Program",
            icon: <ListBulletIcon className="w-8 h-8"/>,
            iconActive: <TvIconSolid className="w-8 h-8"/>,
            href: "/program-tv",
        },
    ];

    return (
        <div className="fixed bottom-0 w-screen h-auto bg-neutral-950 z-60 px-3">
            <ul className="space-x-2 flex justify-between sm:justify-evenly">
                {NavItems.map((item) =>
                    <li key={item.title}>
                        <NavItem title={item.title} icon={item.icon} href={item.href}/>
                    </li>
                )}
            </ul>
        </div>
    );
}
